import React, { useEffect, useState } from 'react';
import { Table, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import api from '../../utils/axiosConfig';
import { formatDate } from '../../utils/formatDate';
import './OnlineAdmission.css';
import NoDataFoundLayout from '../../layouts/NoDataFoundLayout';

const OnlineAdmission = () => {

  const [topNewsData, setTopNewsData] = useState([]);
  const [admissionHeadline, setAdmissionHeadline] = useState([]);
  const [admissionProgramData, setAdmissionProgramData] = useState([]);

 

  useEffect(() => {
    api.get(`headline?headline_type_id=1`).then((res) => {
      setTopNewsData(res.data);
    });

    api.get(`headline?headline_type_id=2`).then((res) => {
      setAdmissionHeadline(res.data);
    });

    api.get(`admission-ongoing-programs`).then((res) => {
      setAdmissionProgramData(res.data);
    });

    localStorage.setItem('previousPathname', 'online-admission/files/')
  }, []);

  // Filter and group programs by school_id
  const groupBySchool = (data) => {
    return data.reduce((acc, item) => {
        if (!acc[item.school_id]) {
          acc[item.school_id] = {
            school_name: item.school_name,
            programs: [],
          };
        }
        acc[item.school_id].programs.push(item);
      return acc;
    }, {});
  };

  const groupedData = groupBySchool(admissionProgramData);

  return (
    <div>
      <section className="marquee-container px-2">
      <div className="marquee mt-2">
      
        {
          topNewsData.length !== 0 ? (
            topNewsData.map((item, index) => (
              <div key={index} className='me-5'>
                <NavLink to={`view-pdf/${item.file_path}`}  className="text-decoration-none" title="Click to download file" target="_blank">  
                     <span dangerouslySetInnerHTML={{ __html: item.caption_text }} />
                </NavLink>
              </div>
            ))
          ) : (
            <NoDataFoundLayout errorCaption="No news has been uploaded." />
          )
        }
              
      </div>
    </section>

      {/* Display Admission Headlines */}
      {admissionHeadline.length !== 0 && (
        admissionHeadline.map((item, index) => (
          <div key={index} className='bg-white'>
            <span dangerouslySetInnerHTML={{ __html: item.caption_text }} />
          </div>
        ))
      )}

      {/* Display Admission Programs Grouped by School */}
      <div className='bg-ash border'>
        {Object.values(groupedData).map((school, schoolIndex) => (
          <section key={schoolIndex} className='border p-2 my-5 bg-white rounded'>
            <h5 className='text-center text-tomato'>School Of {school.school_name}</h5>
            <div className="table-responsive">
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th width="42%">Program</th>
                    <th width="10%">Admission Semester</th>
                    <th>Application Start</th>
                    <th>Application Deadline</th>
                    <th>Circular</th>
                    <th width="13%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {school.programs.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        {item.program_name}. 
                        <a href={item.program_read_more_link} className="read-more mx-1" target="_blank" rel="noopener noreferrer">
                          Read more
                        </a>
                      </td>
                      <td>{item.admission_semester}</td>
                      <td>{formatDate(item.application_start)}</td>
                      <td>{formatDate(item.application_deadline)}</td>
                      <td>
                        <Button as={NavLink} to={`view-pdf/${item.circular_path}`} target='_blank' variant="outline-danger" size="sm" className="w-100 rounded-pill">
                          CIRCULAR
                        </Button>
                      </td>
                      <td>
                        <Button
                          as={NavLink}
                          to={`apply/${item.program_id}/${item.program_name}/${item.online_adm_sem_id}/${item.admission_semester}`}
                          variant="outline-success"
                          size="sm"
                          style={{ width: '120px' }}
                          className="rounded-pill"
                        >
                          APPLY NOW
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default OnlineAdmission;
